import { MemberDetailsPage, MembersOverview } from '@members/routes';
import { NotFound } from '@routes/NotFound';
import { Route, Routes } from 'react-router-dom';

export const MembersRoutes = () => (
    <Routes>
        <Route index element={<MembersOverview />} />
        <Route path=":id" element={<MemberDetailsPage />} />
        <Route path="*" element={<NotFound />} />
    </Routes>
);
